import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import CustomerAddressDummyRepository
  from './infrastructure/repositories/customer-address-dummy-repository/customer-address-dummy-repository';
import CustomerAddressHttpRepository from './infrastructure/repositories/customer-address-http-repository';
import VueStateManager from './infrastructure/state/vue-state-manager';

// Application
import UpdateCustomerAddressCommand from './application/commands/update-customer-address-command';
import ChooseYourDocumentsService from './application/services/choose-your-documents-service';
import AddressService from './application/services/address-service';
import ProofOfAddressService from './application/services/proof-of-address-service';

// Domain
import { CustomerAddressRepository } from './domain/repositories/customer-address-repository';
import { StateManager } from './domain/state/state-manager';

export default function setupCustomerAddress(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';

  container
    .bind<CustomerAddressRepository>(TYPES.CUSTOMER_ADDRESS_REPOSITORY)
    .to(
      withDummies
        ? CustomerAddressDummyRepository
        : CustomerAddressHttpRepository,
    ).inSingletonScope();

  container
    .bind<StateManager>(TYPES.CUSTOMER_ADDRESS_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<UpdateCustomerAddressCommand>(TYPES.UPDATE_CUSTOMER_ADDRESS_COMMAND)
    .to(UpdateCustomerAddressCommand)
    .inSingletonScope();

  container
    .bind<ChooseYourDocumentsService>(TYPES.CHOOSE_YOUR_DOCUMENTS_SERVICE)
    .to(ChooseYourDocumentsService)
    .inSingletonScope();

  container
    .bind<AddressService>(TYPES.ADDRESS_SERVICE)
    .to(AddressService)
    .inSingletonScope();

  container
    .bind<ProofOfAddressService>(TYPES.PROOF_OF_ADDRESS_SERVICE)
    .to(ProofOfAddressService)
    .inSingletonScope();
}
